import i18n from "@/plugins/i18n";

/**
 * Translate a key using the i18n plugin.
 * Returns an empty string if the key is undefined or empty.
 */
export const translate = (key?: string): string => {
  return key ? i18n.t(key) : "";
};
